import React, { useEffect, useState } from 'react';
import { useDebounce } from 'use-debounce';
import { useRealizedGainLoss } from '../../../../../../hooks/useRealizedGainLoss';
import { GainLossDetailsEmpty } from '../../../GainLossDetailsEmpty/GainLossDetailsEmpty';
import { GainLossDetailsError } from '../../../GainLossDetailsError/GainLossDetailsError';
import { GainLossDetailsLoading } from '../../../GainLossDetailsLoading/GainLossDetailsLoading';
import { RealizedGainLossDetailsContent } from './components/RealizedGainLossDetailsContent/RealizedGainLossDetailsContent';
import { PositionsDTO, TaxLotDetailsDTO } from '../../../GainLossMobile/GainLossMobile.meta';
import { TaxLotMobile } from '../../../GainLossMobile/components/TaxLotMobile';
import { PositionMobile } from '../../../GainLossMobile/components/PositionMobile';

interface Props {
  title: string;
}

export const RealizedGainLossDetails = ({ title }: Props) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [positionMobile, setPositionMobile] = useState<PositionsDTO | null>(null);
  const [taxLotsMobile, setTaxLotsMobile] = useState<TaxLotDetailsDTO[] | null>(null);

  const [debouncedSearchTerm] = useDebounce(searchTerm, 200);

  const { data, isFetching, isError, refetch } = useRealizedGainLoss();

  useEffect(() => {
    setPositionMobile(null);
    setTaxLotsMobile(null);
  }, [isFetching]);

  if (isFetching) {
    return <GainLossDetailsLoading title={title} />;
  }

  if (isError) {
    return <GainLossDetailsError title={title} onRetry={refetch} />;
  }

  if (!data) {
    return null;
  }

  const { tableData } = data;

  if (!tableData) {
    return null;
  }

  if (tableData.rows.length === 0) {
    return <GainLossDetailsEmpty title={title} />;
  }

  if (taxLotsMobile) {
    return (
      <TaxLotMobile type="realized" taxLots={taxLotsMobile} goBack={() => setTaxLotsMobile(null)} />
    );
  }

  if (positionMobile) {
    return (
      <PositionMobile
        type="realized"
        position={positionMobile}
        goBack={() => setPositionMobile(null)}
        setTaxSlots={setTaxLotsMobile}
      />
    );
  }

  return (
    <RealizedGainLossDetailsContent
      data={data}
      debouncedSearchTerm={debouncedSearchTerm}
      setSearchTerm={setSearchTerm}
      searchTerm={searchTerm}
      title={title}
      setPositionMobile={setPositionMobile}
    />
  );
};
